import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { HeaderSpacerProps } from "./types";

/**
 * Reserves exactly the height the fixed <Header /> occupies, in CSS only, so
 * the server HTML is already correct on first paint and nothing snaps into
 * place on hydration.
 *
 * The classes below deliberately MIRROR header.tsx's own box: `~p-2/8` fluid
 * padding and a 1px border on every side, wrapping the 250x62.5px logo
 * (`w-[250px] aspect-[4/1]`). The header's height is fluid — roughly 80px at
 * 375px wide and 128.5px at 1536px and above — so a hardcoded value would be
 * wrong at nearly every width. If header.tsx's padding, border, or logo size
 * ever changes, change it here in the same commit.
 */
function HeaderSpacer({ className, ...props }: HeaderSpacerProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <div
      aria-hidden="true"
      data-header-spacer=""
      className={cn(
        "w-full ~p-2/8 border border-transparent",
        className,
        classes,
      )}
      {...native}
    >
      <div className="w-[250px] aspect-[4/1]" />
    </div>
  );
}

export default HeaderSpacer;
